import React, { useState, useEffect } from 'react';
import { Redirect, RouteComponentProps } from 'react-router-dom';
import { Storage } from 'react-jhipster';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { login } from 'app/shared/reducers/authentication';
import LoginPage from './login-page';
import { hasAnyAuthority } from 'app/shared/auth/private-route';
import { AUTHORITIES } from 'app/config/constants';

export const Login = (props: RouteComponentProps<any>) => {
  const dispatch = useAppDispatch();
  const account = useAppSelector(state => state.authentication.account);
  const ecole = useAppSelector(state => state.ecole.entity);
  const anneeScolaire = useAppSelector(state => state.anneeScolaire.entityActive);
  const isAuthenticated = useAppSelector(state => state.authentication.isAuthenticated);
  const loginError = useAppSelector(state => state.authentication.loginError);
  const handleLogin = (username, password, rememberMe = false) => dispatch(login(username, password, rememberMe));
  const { location } = props;
  const { from } = (location.state as any) || { from: { pathname: '/ecole', search: location.search } };
  const { home } = (location.state as any) || {
    home: { pathname: `/home/${ecole && ecole.id}/${anneeScolaire.id}`, search: location.search },
  };
  const { classeProf } = (location.state as any) || { classeProf: { pathname: `/classe/${ecole && ecole.id}`, search: location.search } };

  if (isAuthenticated) {
    if (account && hasAnyAuthority(account.authorities, [AUTHORITIES.ADMIN])) {
      return <Redirect to={from} />;
    }
    if (account && ecole.id !== null && hasAnyAuthority(account.authorities, [AUTHORITIES.PROFESSEUR])) {
      return <Redirect to={classeProf} />;
    }
    if (
      account &&
      ecole.id !== null &&
      anneeScolaire?.id !== null &&
      hasAnyAuthority(account.authorities, [
        AUTHORITIES.DIRECTEUR,
        AUTHORITIES.DIRECTEUR_ETUDE,
        AUTHORITIES.SURVEILLANT_GENERAL,
        AUTHORITIES.COMPTABLE,
        AUTHORITIES.SECRETAIRE,
      ])
    ) {
      return <Redirect to={home} />;
    }
  }

  return <LoginPage handleLogin={handleLogin} loginError={loginError} />;
};

export default Login;
